import { Close } from '@mui/icons-material';
import { Autocomplete, TextField, Chip, SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { FunctionComponent } from 'react';
import { capitalizeString, User } from '../../services';
import {
  FilterContainer,
  FilterIcon,
  FilterAutocomplete,
  FilterContentContainer,
  FilterName,
  FilterPhoneNumber,
} from './autocomplete-field.styles';

type filterType =
  | 'engage-number'
  | 'location'
  | 'sales-rep'
  | 'assigned-to-others';

interface IAutocompleteField {
  filterType: filterType;
  icon: OverridableComponent<SvgIconTypeMap<Record<string, unknown>, 'svg'>> & {
    muiName: string;
  };
  options: User[];
  value?: User[];
  updateFilters: (filter: filterType, ids: (string | number)[]) => void;
}

export const AutocompleteField: FunctionComponent<IAutocompleteField> = ({
  filterType,
  icon,
  options,
  value,
  updateFilters,
}) => {
  const placeholder = capitalizeString(filterType.split('-').join(' '));
  const dataE2e = `${filterType}-inbox-filter`;
  const CloseIcon = Close;
  const Icon = icon;

  return (
    <FilterContainer>
      <FilterIcon>
        <Icon />
      </FilterIcon>
      <FilterAutocomplete>
        <Autocomplete
          data-e2e={dataE2e}
          disableCloseOnSelect={true}
          freeSolo
          fullWidth
          getOptionLabel={(option) => (option as User).name}
          key={placeholder}
          multiple
          options={options}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label={placeholder}
              variant="filled"
              InputProps={{
                ...params.InputProps,
                style: {
                  width: '442px',
                },
              }}
            />
          )}
          renderOption={(props, option) => (
            <li {...props}>
              <FilterContentContainer data-e2e={`${dataE2e}-${option.jnid}`}>
                <>
                  <FilterName>{option.name}</FilterName>
                  <FilterPhoneNumber>{option.phone}</FilterPhoneNumber>
                </>
              </FilterContentContainer>
            </li>
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                deleteIcon={<CloseIcon sx={{ color: '#263238 !important' }} />}
                label={(option as User).name}
                {...getTagProps({ index })}
                sx={{
                  borderColor: '#263238',
                  color: '#263238',
                  fontFamily: 'Roboto',
                  fontSize: '14px',
                }}
                variant="outlined"
              />
            ))
          }
          value={value}
          onChange={(e, results) => {
            const ids = results.map(
              (result) => (result as User).jnid || (result as User).id
            );
            updateFilters(filterType, ids);
          }}
        />
      </FilterAutocomplete>
    </FilterContainer>
  );
};
